// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"XE-z","smallCardRow":"YE-z","largeCardRow":"ZE-z","productSearchRow":"_E-z","curatedRow":"aF-z"};